import { inject, Injectable } from "@angular/core";
import { SpatialService } from "./spatial.service";
import type { ScreenPoint } from "@arcgis/core/core/types";
import type MapView from "@arcgis/core/views/MapView";

@Injectable({
    providedIn: "root"
})
export class MapUtilsService {

    spatialService = inject(SpatialService);

    getScreenPosition(geometry: any, view: MapView): ScreenPoint {
        switch (geometry.type) {
            case "polygon":
            case "rectangle":
            case "circle":
                return view.toScreen(this.spatialService.centroid(geometry));
            case "polyline":
                return view.toScreen(geometry.extent.center);
            case "extent":
                return view.toScreen(geometry.center);
            case "point":
                return view.toScreen(geometry);
            default:
                return null;
        }
    }
}
